export default __webpack_public_path__ + "assets/samples/grainG.mp3";